import { setDefaults as i } from "./index86.mjs";
import { setI18n as r } from "./index85.mjs";
var p = {
  type: "3rdParty",
  init: function(t) {
    i(t.options.react), r(t);
  }
};
export {
  p as initReactI18next
};
